import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
/* API LIST */
import { resetPassword } from '../api/user'
/* CUSTOM HOOKS */
import useAlert from '../lib/useAlert'
/* LIB FUNCTIONS */
import validation from '../lib/validation'
/* COMPONENTS */
import BPFormInput from '../components/BPFormInput'
import LockButton from 'components/LockButton'
import BPToast from 'components/BPToast'

const ResetPasswordForm = React.forwardRef((props, ref) => {
  const { t } = useTranslation()
  const Yup = validation(t)
  const { openAlert } = useAlert()
  const [values] = useState({ old_password: '', password: '', verifyPassword: '' })
  const [showOldPassword, setShowOldPassword] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const toastRef = useRef()
  const formik = useFormik({
    initialValues: values,
    enableReinitialize: true,
    validationSchema: Yup.object({
      old_password: Yup.string()
        .required()
        .label(t('new_password')),
      password: Yup.string()
        .min(8)
        .max(15)
        .required()
        .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_])[A-Za-z\d!@#$%^&*()_ıIİçÇşŞöÖüÜğĞ]{8,15}$/, t('error_password_match'))
        .label(t('new_password')),
      verifyPassword: Yup.string()
        .min(8)
        .max(15)
        .required()
        .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_])[A-Za-z\d!@#$%^&*()_ıIİçÇşŞöÖüÜğĞ]{8,15}$/, t('error_password_match'))
        .label(t('verify_password')),
    }),

    onSubmit: (values) => {
      if (values.password === values.verifyPassword) {
        // console.log(values)
        resetPassword(values).then((data) => {
          if (data.P_RESULT_CODE === 0) {
            // toastRef.current.showMessage({ message: 'Şifreniz başarıyla güncellenmiştir.', timeout: 3000 })
            props.afterAccept(true)
          } else {
            openAlert('error', true, data.P_RESULT_MESSAGE)
          }
        })
      } else {
        openAlert('error', true, t('password_does_not_match'))
      }
    },
  })

  const changeFormikField = (label, value) => {
    formik.setFieldValue(label, value)
  }

  const validateFormik = () => {
    formik.validateForm()
  }
  const cbFormikValidateForm = useCallback(validateFormik, [])

  useEffect(() => {
    cbFormikValidateForm()
  }, [cbFormikValidateForm])

  return (
    <>
      <BPToast ref={toastRef} />
      <form onSubmit={formik.handleSubmit}>
        <div className="alert alert-warning">
          {t('error_password_match')}
        </div>
        <div className='row'>
          <div className='col-12'>
            <BPFormInput
              label={t('old_password')}
              name='password'
              type={showOldPassword ? 'text' : 'password'}
              size='sm'
              required
              value={formik.values.old_password}
              onBlur={formik.handleBlur}
              onChange={(val) => changeFormikField('old_password', val)}
              error={formik.errors.old_password && formik.touched.old_password && formik.errors.old_password}
              rightElement={<LockButton showPassword={showOldPassword} toggle={() => setShowOldPassword(!showOldPassword)} />}
            />
          </div>
          <div className='col-12'>
            <BPFormInput
              label={t('new_password')}
              name='password'
              type={showPassword ? 'text' : 'password'}
              size='sm'
              required
              value={formik.values.password}
              onBlur={formik.handleBlur}
              onChange={(val) => changeFormikField('password', val)}
              error={formik.errors.password && formik.touched.password && formik.errors.password}
              rightElement={<LockButton showPassword={showPassword} toggle={() => setShowPassword(!showPassword)} />}
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <BPFormInput
              label={t('verify_password')}
              name='verifyPassword'
              type={showPassword ? 'text' : 'password'}
              size='sm'
              required
              value={formik.values.verifyPassword}
              onBlur={formik.handleBlur}
              onChange={(val) => changeFormikField('verifyPassword', val)}
              error={formik.errors.verifyPassword && formik.touched.verifyPassword && formik.errors.verifyPassword}
            />
          </div>
        </div>
        {
          <button type='submit' style={{ visibility: 'hidden' }} ref={ref}>
            Submit
          </button>
        }
      </form>
    </>
  )
})

export default ResetPasswordForm
